/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { MyContext } from '../../Context/MyProvider';

const Test = ({ setOpen, open, Images, index }) => {

    const { BaseUrl } = useContext(MyContext);
    const [lightboximg, setLightBoxImg] = useState([]);

    useEffect(() => {
        const FilterImg = Images.map((item) => ({ src: BaseUrl + item }));
        setLightBoxImg(FilterImg);
    }, [Images]);

    return (
        <div>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={lightboximg}
                index={index}
                plugins={[Zoom]}
            />
        </div>
    );
};

export default Test;
/* jshint ignore:end */